export const Y_TOKEN = 'j_token';
export const Y_W_USER = 'j_w_user';